import { Directive, HostBinding, Input, OnDestroy, OnInit, inject, input } from '@angular/core';

import {AppDropdownDirective} from './dropdown.directive';

@Directive({
    selector: '[appDropdownLink]',
    standalone: true
})
export class DropdownLinkDirective implements OnInit, OnDestroy {
	public readonly group = input<any>(undefined);

	@HostBinding('class.open')
	@Input()
	get open(): boolean {
		return this._open;
	}

	set open(value: boolean) {
		this._open = value;
		if (value) {
			this.nav.closeOtherLinks(this);
		}
	}

	protected _open: boolean;
	protected nav: AppDropdownDirective;

	public constructor() {
		const nav = inject<AppDropdownDirective>(AppDropdownDirective);

		this.nav = nav;
	}

	public ngOnInit(): any {
		this.nav.addLink(this);
	}

	public ngOnDestroy(): any {
		this.nav.removeGroup(this);
	}

	public toggle(): any {
		this.open = !this.open;
	}
}
